/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, heights, spacing, mediaQuery } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FOOTER STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	footer: {
		// parent is inner in content_styles
		// outline: '1px solid #f33',
		width: '100%',
		height: hasRewardsComponent => hasRewardsComponent ? pxToEm(25) : pxToEm(35),
        bottom: hasRewardsComponent => hasRewardsComponent ? pxToEm(70) : '0em',
        padding: replacePXinStringWithEM(`0px ${spacing.sides} 0px`), // top and bottom on header and footer
		position: 'absolute',
		left: '0',
		zIndex: '4',
        display: 'flex',
        alignItems: 'center',


        // ~~~~ ANIMATION INTRO ~~~~ //
		// moved to app_styles so these only animate once and not every render
		// transform: 'translate3d(0, 100%, 0)', // pull off screen to start
		// animationName: 'slideInUp',
		// animationDelay: '.6s',
		// animationDuration: '.3s',
		// animationFillMode: 'forwards',

		'& .inner': {
			position: 'relative',
			lineHeight: '0',
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			// paddingTop: pxToEm(7),
			'& .logo.insticator .logoimage': {
				fontSize: '115%'
			},
			'& .logo.giphy': {
				position: 'absolute',
				bottom: pxToEm(0),
				right: pxToEm(5)
			}
		},
        '&.large-true': {
            fontSize: '115%'
        }
	},
	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        footer: { fontSize: '110%' }
    },
    [mediaQuery.medium]: {
		footer: { fontSize: '100%' }
	},
    [mediaQuery.thin]: {
		footer: { fontSize: '95%' }
	}
};
